import axios from 'axios';

// Create an axios instance with base URL
const api = axios.create({
  baseURL: '/api', // Update this to match your backend server URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    // Add any request pre-processing here
    // For example, adding auth tokens
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Enhanced error logging for troubleshooting
    console.error('API Error:', error);
    
    // Create a more detailed error object
    const customError = {
      message: error.response?.data?.message || error.message || 'An unknown error occurred',
      status: error.response?.status || 500,
      details: error.response?.data || {},
      isAxiosError: error.isAxiosError || false,
      code: error.code || 'UNKNOWN_ERROR'
    };
    
    // Log the formatted error for debugging
    console.error('Formatted error:', customError);
    
    return Promise.reject(customError);
  }
);

export default api; 